export * from './dossie-slice';
